import React from 'react';
import { SurveyQuestion } from '../../../../../../../../entities/survey_engine/SurveyQuestion';
import { placeholder } from '../../../utils/placeholder';
import { InputFormField } from '../../../../../../../../components/InputFormField';
import { UseFormRegister } from 'react-hook-form';
import { camelCase } from 'lodash';
import { SurveyQuestionFieldType } from '../../../../../../../../entities/survey_engine/SurveyQuestionFieldType';

interface PropTypes {
  question: SurveyQuestion;
  formRegister: UseFormRegister<any>;
  disabled?: boolean;
}

export function DefaultQuestionInput(props: PropTypes) {
  const type = getInputType(props.question.type);

  return (
    <InputFormField
      type={type}
      registerReturn={props.formRegister(camelCase(props.question.title), {
        required: props.question.mandatory,
      })}
      fieldName={props.question.title}
      placeholder={placeholder(props.question)}
      isRequired={props.question.mandatory}
      classNames={'form-control fs-5'}
      hideHeader={true}
      disabled={props.disabled ?? false}
    />
  );
}

function getInputType(fieldType: SurveyQuestionFieldType) {
  switch (fieldType) {
    case SurveyQuestionFieldType.Url:
      return 'url';
    case SurveyQuestionFieldType.Email:
      return 'email';
    default:
      return 'text';
  }
}
